import { getNavi, getPage, getFront, getContact, getBlogs, getPress, getMedia, getBWinMedia, getJobs, getJobContainers } from '../api/contentfulAPI';
import { getDate } from '../api/dateAPI';
import { getProductsInCollection } from '../api/shopifyAPI';

export const RECEIVE_NAVI = 'RECEIVE_NAVI';
export const RECEIVE_PAGES = 'RECEIVE_PAGES';
export const RECEIVE_DATE = 'RECEIVE_DATE';
export const SWITCH_LANG = 'SWITCH_LANG';
export const RECEIVE_FRONTPAGE = 'RECEIVE_FRONTPAGE';
export const RECEIVE_INSTAGRAM = 'RECEIVE_INSTAGRAM';
export const RECEIVE_CONTACT = 'RECEIVE_CONTACT';
export const RECEIVE_BLOGS = 'RECEIVE_BLOGS';
export const RECEIVE_PRESS = 'RECEIVE_PRESS';
export const RECEIVE_MEDIA = 'RECEIVE_MEDIA';
export const RECEIVE_COLLECTIONS = 'RECEIVE_COLLECTIONS';
export const RECEIVE_BWINMEDIA = 'RECEIVE_BWINMEDIA';
export const RECEIVE_JOBS = 'RECEIVE_JOBS';
export const RECEIVE_JOB_CONTAINERS = 'RECEIVE_JOB_CONTAINERS';

const isFetching = {};

export const fetchNavi = (locale) => (dispatch, state) => {
  const FLAG = 'fetchNavi';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getNavi(locale).then(items => {
      isFetching[FLAG] = false;
      dispatch(receiveNavi(items))
    });
  }
};

const receiveNavi = (items) => ({
  type: RECEIVE_NAVI,
  items: items.map(item => {
    return {...item.fields};
  }),
});

export const fetchPage = (slug, locale) => (dispatch) => {
  const FLAG = `fetchPage_${slug}`;
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getPage(slug, locale).then(item => {
      isFetching[FLAG] = false;
      dispatch(receivePage(item))
    });
  }
}

const receivePage = (item) => {
  return {
    type: RECEIVE_PAGES,
    item
  }
}

// fetch and get the front page head
export const fetchFront = (locale, time) => (dispatch) => {
  const FLAG = 'fetchFront';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getFront(locale).then(item => {
      isFetching[FLAG] = false;
      dispatch(receiveFront(item, time));
    })
  }
}

const receiveFront = (data, time) => {
  return {
    type: RECEIVE_FRONTPAGE,
    data: {
      header:data.header,
      lifts:data.lifts
    }
  }
}


export const fetchDate = () => (dispatch) => {
  const FLAG = 'fetchDate';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getDate().then(date => {
      isFetching[FLAG] = false;
      dispatch(receiveDate(date))
    })
  }
};

const receiveDate = (date) => ({
  type: RECEIVE_DATE,
  date,
});

export const switchLang = () => ({
  type: SWITCH_LANG
});

// fetch and receive instagram
export const fetchInstagram = () => (dispatch) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = true;
  return fetch('https://ottoboni.fi.cloudplatform.fi/helpers/instagram/GetLatestInstagramImages.php?user=4782232938&count=2&access_token=4782232938.1677ed0.48b05f6bf6194034af12a044db0a6bf3')
    .then(x=>x.json())
    .then(y=>{
      dispatch(receiveInstagram(JSON.parse(y).data));
    })
}

const receiveInstagram = (data) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_INSTAGRAM,
    data
  };
}

// fetch and receive the contact page content
export const fetchContact = (locale) => (dispatch) => {
  const FLAG = 'fetchContact';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getContact(locale).then(data => {
      isFetching[FLAG] = false;
      dispatch(receiveContact(data))
    })
  }
}

const receiveContact = (data) => {
  return {
    type: RECEIVE_CONTACT,
    data
  }
}

export const fetchBlog = (locale, limit, offset) => (dispatch) => {
  const FLAG = 'fetchBlog';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getBlogs(locale, limit, offset).then(data => {
      dispatch(receiveBlogs(data))
    });
  }
};

const receiveBlogs = (blogs) => {
  const FLAG = 'fetchBlog';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_BLOGS,
    data: blogs
  };
};

export const fetchPress = (locale, limit, offset) => (dispatch) => {
  const FLAG = 'fetchPress';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getPress(locale, limit, offset).then(data => {
      dispatch(receivePress(data))
    });
  }
};

const receivePress = (releases) => {
  const FLAG = 'fetchPress';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_PRESS,
    data: releases
  };
};


export const fetchMedia = (locale) => (dispatch) => {
  const FLAG = 'fetchMedia';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getMedia(locale).then(data => {
      dispatch(receiveMedia(data))
    });
  }
};

const receiveMedia = (media) => {
  const FLAG = 'fetchMedia';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_MEDIA,
    data: media
  };
};

export const fetchCollection = (id) => (dispatch) => {
  const FLAG = 'fetchGiftCard';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getProductsInCollection(id).then(collection => {
      isFetching[FLAG] = false;
      dispatch(receiveCollection(collection))
    });
  }
};

const receiveCollection = (collection) => ({
  type: RECEIVE_COLLECTIONS,
  collection
});


export const fetchBWInMedia = (locale, limit, offset) => (dispatch) => {
  const FLAG = 'fetchBWInMedia';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getBWinMedia(locale, limit, offset).then(data => {
      dispatch(receiveBWInMedia(data))
    });
  }
};

const receiveBWInMedia = (articles) => {
  const FLAG = 'fetchBWInMedia';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_BWINMEDIA,
    data: articles
  };
};

export const fetchJobs = (locale) => (dispatch) => {
  const FLAG = 'fetchJobs';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getJobs(locale).then(data => {
      dispatch(receiveJobs(data))
    });
  }
};

const receiveJobs = (jobs) => {
  const FLAG = 'fetchJobs';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_JOBS,
    data: jobs
  };
};

export const fetchJobContainers = (locale) => (dispatch) => {
  const FLAG = 'fetchJobContainers';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getJobContainers(locale).then(data => {
      dispatch(receiveJobContainers(data))
    });
  }
};

const receiveJobContainers = (jobContainers) => {
  const FLAG = 'fetchJobContainers';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_JOB_CONTAINERS,
    data: jobContainers
  };
};


// WEBPACK FOOTER //
// ./src/redux/actions.js